module.exports = __webpack_public_path__ + "img/exe.3fda0622.svg";